import { render, staticRenderFns } from "./contactData.vue?vue&type=template&id=06ff73ee&scoped=true&"
import script from "./contactData.vue?vue&type=script&lang=js&"
export * from "./contactData.vue?vue&type=script&lang=js&"
import style0 from "./contactData.vue?vue&type=style&index=0&id=06ff73ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff73ee",
  null
  
)

export default component.exports